import React from "react";
import styled, { keyframes, css } from "styled-components";
import { ReactComponent as InfoSvg } from "../../../assets/info.svg";

const NotificationPosition = keyframes`
  /* 0.500 */
  0% {
    transform: translateX(50%) translateY(65px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
  }
  50% {
    transform: translateX(50%) translateY(-15px);
    animation-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
  }
  100% {
    transform: translateX(50%) translateY(0px);
  }
`;
const NotificationPositionOut = keyframes`
  /* 0.500 */
  0% {
    transform: translateX(50%) translateY(0px);
    animation-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
  }
  100% {
    transform: translateX(50%) translateY(-125px);
  }
`;
const NotificationOpacity = keyframes`
  /* 0.250 */
  0% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.17, 0.17, 0.22,1);
  }
  100% {
    opacity: 1;
  }
`;
const NotificationOpacityOut = keyframes`
/* 0.250 */
0% {
  opacity: 1;
   animation-timing-function: cubic-bezier(0.17, 0.17, 0.22,1);
 }  
 100% {
   opacity: 0;
 }
`;
export const NotificationPositionAnim = css`
  ${NotificationPosition}
`;
export const NotificationPositionOutAnim = css`
  ${NotificationPositionOut}
`;
export const NotificationOpacityAnim = css`
  ${NotificationOpacity}
`;
export const NotificationOpacityOutAnim = css`
  ${NotificationOpacityOut}
`;
export const NotificationContainer = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #db4646;
  right: 50%;
  font-size: 12px;
  transform: translateX(50%);
  animation: ${NotificationPositionAnim};
  animation: ${(p) => (p.fadeOut ? NotificationPositionOutAnim : null)};
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  overflow: hidden;
  z-index: 4;
  pointer-events: none;
  p {
    width: 80%;
    padding: 20px;
  }
  & > svg {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
  }
`;
export const NotWrapper = styled.div`
  width: 315px;
  height: 667px;
  overflow: hidden;
`;
export const NotificationBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background: #ffb000;
  padding: 18px;
  border-radius: 10px;
  animation: ${NotificationOpacity};
  animation: ${(p) => (p.fadeOut ? NotificationOpacityOut : null)};
  animation-duration: 0.25s;
  animation-delay: ${(p) => (p.fadeOut ? " 0.083s" : "0s")};
  animation-fill-mode: forwards;
  margin-top: 30px;
  pointer-events: auto;
  svg {
    top: 18px;
    position: absolute;
    right: 18px;
  }
`;
export const NotificationIcon = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #db4646;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    position: unset;
  }
`;

export const Icon = () => {
  return (
    <NotificationIcon>
      <InfoSvg />
    </NotificationIcon>
  );
};
